import { render, staticRenderFns } from "./TruckMeasurement.vue?vue&type=template&id=a264d0c8&scoped=true&"
import script from "./TruckMeasurement.vue?vue&type=script&lang=js&"
export * from "./TruckMeasurement.vue?vue&type=script&lang=js&"
import style0 from "./TruckMeasurement.vue?vue&type=style&index=0&id=a264d0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a264d0c8",
  null
  
)

/* custom blocks */
import block0 from "./TruckMeasurement.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports